import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);
//路由跳转新页面 默认显示在最顶端
 
export default new Router({
  routes: [
    {
      path: '/',
      component: resolve => require(['@/page/checkNum'], resolve),
      meta: {
        title: '验证工号',
        keepAlive: false
      }
    },
    {
      path: '/ForgetPwd',
      name: 'ForgetPwd',
      component: resolve => require(['@/page/forgetPwd'], resolve),
      meta: {
        title: '忘记密码',
        keepAlive: false
      }
    },
    {
      path: '/ChangeResult',
      name: 'ChangeResult',
      component: resolve => require(['@/page/changeResult'], resolve),
      meta: {
        title: '重设密码结果',
        keepAlive: false
      }
    },
    // ===== 供应商VPN密码自助重置（入口: index.html#/VendorAccount）=====
    {
      path: '/VendorAccount',
      name: 'VendorAccount',
      component: resolve => require(['@/page/vendorAccount'], resolve),
      meta: {
        title: '重置密码',
        keepAlive: false
      }
    },
    {
      path: '/VendorReset',
      name: 'VendorReset',
      component: resolve => require(['@/page/vendorReset'], resolve),
      meta: {
        title: '重置密码',
        keepAlive: false
      }
    },
    {
      path: '/VendorResult',
      name: 'VendorResult',
      component: resolve => require(['@/page/vendorResult'], resolve),
      meta: {
        title: '操作结果',
        keepAlive: false
      }
    },
  ],
});


// WEBPACK FOOTER //
// ./src/router/index.js